export const selectedWeeds = (state) => {
  return state.weeds.weeds.filter(weed => state.weeds.selectedWeedIds.includes(weed.id))
}
